import { render, staticRenderFns } from "./KarigarJobs.vue?vue&type=template&id=198cd8dc&"
import script from "./KarigarJobs.vue?vue&type=script&lang=js&"
export * from "./KarigarJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports